import { render, staticRenderFns } from "./CommunityChatRoomModal.vue?vue&type=template&id=3322e527&scoped=true&"
import script from "./CommunityChatRoomModal.vue?vue&type=script&lang=js&"
export * from "./CommunityChatRoomModal.vue?vue&type=script&lang=js&"
import style0 from "./CommunityChatRoomModal.vue?vue&type=style&index=0&id=3322e527&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3322e527",
  null
  
)

export default component.exports